import {memo} from 'react';

import styles from '@styles/dropAuction/howItWork.module.scss';

import StepOne from './stepOne';
import StepTwo from './stepTwo';
import StepThree from './stepThree';

const HowItWork = () => {
	return (
		<div className={styles.howitworkBox}>
			<div className={styles.globalHeading}>
				<h2>How It Works</h2>
			</div>
			<div className='row'>
				<StepOne />
				<StepTwo />
				<StepThree />
			</div>
		</div>
	);
};

export default memo(HowItWork);
